/* eslint-disable import/default */

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import routes from './routes';
require('./favicon.ico'); // Tell webpack to load favicon.ico
import './styles/_main.less';
import { syncHistoryWithStore } from 'react-router-redux';
import store from './store/index';

import * as sessionActions from './actions/sessionActions';

store.dispatch(sessionActions.verifyJwtToken());

// Create an enhanced history that syncs navigation events with the store
const history = syncHistoryWithStore(browserHistory, store);

render(
   <Provider store={store} >
      <Router history={history} routes={routes} />
   </Provider>, document.getElementById('app')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/